import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Background, Header } from "@/components";
import type { User } from '@/shared/types';
import { AUTH, type AuthState } from "@/shared/constants/auth";
import AppItem from '@/components/AppItem';

function AppDashboard({ user, setAuthState }: { user: User | null, setAuthState: (state: AuthState) => void }) {
    const navigate = useNavigate();

	return(
    <div className='gameRepository'>
        <div className="currentGames dark-box">
            <AppItem 
                user={user} 
                setAuthState={setAuthState} 
                title={"Chess"} 
                description={"Play the old fashion chess game."} 
                navigation={"/chess"}
            />
        </div>
    </div>
	);
}

export default AppDashboard;
